import { FC, useId } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TooltipInner } from 'components/tooltip';
import { Switch, Text } from 'components/ui';
import {
  FiasSearchMockWrapper,
  ToggleBlock,
  ToggleWrapper,
  TooltipAnchor,
} from './fias-search-mock.styled';

import { FiasSearchMockInput } from './fias-search-mock-input';

interface Props {
  isDisabled: boolean;
  isActive: boolean;
  error?: string;
  withoutHouseGroups?: boolean;
  isAllAddressesChecked?: boolean;
  /** Если передан, переключатель «Все адреса» блокируется и показывает подсказку. */
  allAddressesTooltip?: string;
}

export const FiasSearchMock: FC<Props> = ({
  isDisabled,
  isActive,
  error,
  withoutHouseGroups,
  isAllAddressesChecked = false,
  allAddressesTooltip,
}) => {
  const tooltipId = useId();

  return (
    <FiasSearchMockWrapper>
      <FiasSearchMockInput
        isActive={isActive}
        isDisabled={isDisabled}
        error={error}
        withoutHouseGroups={withoutHouseGroups}
      />

      <ToggleWrapper>
        <ToggleBlock>
          <TooltipAnchor
            data-tooltip-id={tooltipId}
            data-tooltip-variant="info"
          >
            <Switch
              checked={isAllAddressesChecked}
              disabled={Boolean(allAddressesTooltip)}
            />
          </TooltipAnchor>

          {allAddressesTooltip && (
            <ReactTooltip
              id={tooltipId}
              variant="info"
              place="top"
              className="custom-tooltip"
            >
              <TooltipInner>{allAddressesTooltip}</TooltipInner>
            </ReactTooltip>
          )}
        </ToggleBlock>

        <Text style={{ minWidth: 74 }}>Все адреса</Text>
      </ToggleWrapper>
    </FiasSearchMockWrapper>
  );
};
